<template>
  <admin-confirm-dialog
    :item="item"
    :helper-text="helperText"
    :disabled="disabled"
    title="Bankayı sil"
    description="{name} bankasını silmek istediğinize emin misiniz?"
    confirm-text="Bankayı Sil"
    :save="save"
    :close="close"
  ></admin-confirm-dialog>
</template>

<script>
import AdminConfirmDialog from '@/components/admin/AdminConfirmDialog.vue'

export default {
  components: {
    AdminConfirmDialog,
  },
  props: {
    helperText: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    item: {
      type: Object,
      default: () => ({}),
    },
    save: {
      type: Function,
      default: undefined,
    },
    close: {
      type: Function,
      default: undefined,
    },
  },
}
</script>
